export const CANCELLATION_REASONS = [
  { value: "dog_sick", label: "Hund ist krank" },
  { value: "dog_in_heat", label: "Hund ist läufig" },
  { value: "dog_injured", label: "Hund ist verletzt" },
  { value: "owner_home", label: "Bin selbst zu Hause" },
  { value: "owner_traveling", label: "Verreist / im Urlaub" },
  { value: "schedule_conflict", label: "Terminkonflikt" },
  { value: "time_change", label: "Möchte Uhrzeit ändern" },
  { value: "financial", label: "Finanzieller Grund" },
  { value: "weather", label: "Wetter" },
  { value: "service_unhappy", label: "Unzufrieden mit Service" },
  { value: "provider_switch", label: "Wechsel zu anderem Anbieter" },
  { value: "other", label: "Sonstiges" },
] as const;

export type CancellationReason = typeof CANCELLATION_REASONS[number]["value"];

// Admin-only zusätzliche Stornierungsgründe (nicht im Kundenflow sichtbar)
export const ADMIN_ONLY_CANCELLATION_REASONS = [
  { value: "routes_bug", label: "Routen Bug" },
] as const;

// Für Admin-Formulare: Admin-only Gründe zuerst, dann Standardgründe
export const ADMIN_CANCELLATION_REASONS = [
  ...ADMIN_ONLY_CANCELLATION_REASONS,
  ...CANCELLATION_REASONS,
] as const;

export const getReasonLabel = (reason: string | null): string => {
  if (!reason) return "-";
  const found =
    CANCELLATION_REASONS.find((r) => r.value === reason) ||
    ADMIN_ONLY_CANCELLATION_REASONS.find((r) => r.value === reason);
  return found?.label || reason;
};

// ── Storno-Herkunft (Streaks S0, 15.10.2026) ───────────────────────────────────────────
// Wer hat die Absage VERANLASST (nicht: wer hat geklickt)? Spalte storno_herkunft an
// adventure_bookings, Trigger setze_storno_herkunft (SQL streaks-s0-01). Eine vom Team
// abgesagte Woche darf die Wochen-Serie des Kunden später nicht brechen.
export type StornoHerkunft = "kunde" | "team" | "system";

/** Gründe, die der Kunde setzt (gleiche Liste wie storno_herkunft_ableiten in der DB). */
export const KUNDEN_STORNO_GRUENDE: readonly string[] = [
  "dog_sick", "dog_in_heat", "dog_injured", "owner_home", "owner_traveling",
  "schedule_conflict", "time_change", "financial", "service_unhappy", "provider_switch",
];

/**
 * Vorschlag für das Admin-Formular: Kunden-Grund = kunde, Routen-Bug/Wetter = team,
 * „Sonstiges“/kein Grund = null (Admin muss wählen).
 */
export function herkunftAusGrund(reason: string | null | undefined): Exclude<StornoHerkunft, "system"> | null {
  if (!reason) return null;
  if (KUNDEN_STORNO_GRUENDE.includes(reason)) return "kunde";
  if (reason === "routes_bug" || reason === "weather") return "team";
  return null;
}
